<script>
export default {
  name: "OauthDone",
  mounted() {
    const query = this.$route.query || {};
    const openid = query.openid ? String(query.openid) : "";
    if (!openid) {
      this.$router.replace({ name: "login", query: { error: "登录未完成" } });
      return;
    }
    const id = Number(query.id);
    localStorage.setItem(
      "user",
      JSON.stringify({
        openid,
        id: Number.isNaN(id) ? query.id : id,
        username: query.username ? String(query.username) : "",
      })
    );
    const redirect = query.redirect ? String(query.redirect) : "";
    if (redirect.startsWith("/") && !redirect.startsWith("//")) {
      this.$router.replace(redirect);
      return;
    }
    this.$router.replace({ name: "home" });
  },
};
</script>

<template>
  <div class="min-vh-100 d-flex align-items-center justify-content-center">
    <p class="mb-0">正在进入管理后台…</p>
  </div>
</template>
